// extracted by mini-css-extract-plugin
export default {"container":"MoreResults_container__CBIoZ","btn":"MoreResults_btn__ef86Q"};